import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { useIsMobile } from "@/hooks/useResponsive";
import styles from "../ProfileTable/styles.module.css";

const ROW_COUNT = 10;
const CARD_COUNT = 6;

export const ProfileTableSkeleton = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div aria-label="Loading profiles" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {Array.from({ length: CARD_COUNT }).map((_, i) => (
          <Box key={i} sx={{ p: 1.5, border: "1px solid var(--divider-main)", borderRadius: "var(--border-radius-main)" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" width="50%" height={24} />
            </Box>
            <Skeleton variant="text" width="80%" height={16} />
            <Skeleton variant="text" width="60%" height={16} />
            <Skeleton variant="rounded" width={110} height={28} sx={{ mt: 1 }} />
          </Box>
        ))}
      </div>
    );
  }

  return (
    <table aria-label="Loading profiles" className={styles.table}>
      <colgroup span={6}>
        <col width="20%" />
        <col width="24%" />
        <col width="14%" />
        <col width="14%" />
        <col width="14%" />
        <col width="14%" />
      </colgroup>
      <thead>
        <tr>
          <th>Person</th>
          <th>Relationship Level</th>
          <th>Role</th>
          <th>Market</th>
          <th>Country</th>
          <th>Rep</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <tr key={i}>
            <td>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width="60%" />
              </div>
            </td>
            <td><Skeleton variant="rounded" width={100} height={28} /></td>
            <td><Skeleton variant="text" width="70%" /></td>
            <td><Skeleton variant="text" width="60%" /></td>
            <td><Skeleton variant="text" width="50%" /></td>
            <td><Skeleton variant="text" width="65%" /></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
